/**
 * Delte produksjoner i sidemenyen (§5.1). Menneskets, ikke husets: nøkkelen står under delingene, så et
 * svar på en deling eller en ny deling i Innboks feier lista med.
 */
import { mySharedProductionListSchema, type MySharedProductionList } from '@tvitvi/shared';
import { queryOptions } from '@tanstack/react-query';

import { CACHE } from '@/api/cache-tiers';
import { apiRequest } from '@/api/client';
import { qk } from '@/api/query-keys';

export function mySharedProductionsQueryOptions() {
  return queryOptions({
    queryKey: qk.mySharedProductions(),
    queryFn: ({ signal }): Promise<MySharedProductionList> =>
      apiRequest({
        path: '/me/shares/productions',
        schema: mySharedProductionListSchema,
        signal,
      }),
    ...CACHE.list,
  });
}
